function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M36.985 0H7.963C7.155 0 6.5.655 6.5 1.926V55c0 .345.655 1 1.463 1h40.074c.808 0 1.463-.655 1.463-1V12.978c0-.696-.093-.92-.257-1.085L37.607.257A.884.884 0 0036.985 0z",
  fill: "#e9e9e0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M48.037 56H7.963A1.463 1.463 0 016.5 54.537V39h43v15.537c0 .808-.655 1.463-1.463 1.463z",
  fill: "#ff5364"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.4 42.924h1.668V53H22.4v-6.932l-2.256 5.605h-1.449l-2.27-5.605V53h-1.668V42.924h1.668l2.994 6.891 2.981-6.891zM28.211 53H26.57V42.924h2.898c.428 0 .852.068 1.271.205.419.137.795.342 1.128.615.333.273.602.604.807.991s.308.822.308 1.306c0 .511-.087.973-.26 1.388a2.9 2.9 0 01-.725 1.046c-.31.282-.684.501-1.121.656s-.921.232-1.449.232H28.21V53zm0-8.832v3.992h1.504c.2 0 .398-.034.595-.103.196-.068.376-.18.54-.335s.296-.371.396-.649c.1-.278.15-.622.15-1.032 0-.164-.023-.354-.068-.567a1.637 1.637 0 00-.28-.615 1.657 1.657 0 00-.595-.492c-.255-.132-.593-.198-1.012-.198h-1.23zM38.479 50.648h-4.361V49.35l4.361-6.426h1.668v6.426H41.2v1.299h-1.053V53h-1.668v-2.352zm0-1.298v-4.512L35.58 49.35h2.899z"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M24.5 28a1 1 0 01-1-1V13a1.001 1.001 0 011.538-.844l11 7a1.003 1.003 0 01-.001 1.688l-11 7c-.163.103-.35.156-.537.156zm1-13.179v10.357L33.637 20 25.5 14.821z",
  fill: "#c8bdb8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M28.5 35c-8.271 0-15-6.729-15-15s6.729-15 15-15 15 6.729 15 15-6.729 15-15 15zm0-28c-7.168 0-13 5.832-13 13s5.832 13 13 13 13-5.832 13-13-5.832-13-13-13z",
  fill: "#c8bdb8"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#d9d7ca",
  d: "M37.5.151V12h11.849z"
});

var SvgMp4 = function SvgMp4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
};

export default SvgMp4;